import { Component, OnInit, ViewChild } from '@angular/core';
import { DataTableComponent } from '../data-table/data-table.component';
import * as Enum from '../utils/enums'
import { DialogService } from 'primeng/api';
import { AlertUtil } from '../utils/alert-util';
import { Loading } from '../utils/loading';
import { CaricamentiMassiviService } from '../services/caricamenti-massivi.service';
import { RequestBuilder } from '../classes/request-builder';
import { finalize } from 'rxjs/operators';
import { ICaricamentoMassivo } from '../interfaces/ICaricamentoMassivo';
import { TranslateService } from '@ngx-translate/core';
import { Util } from '../utils/util';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css']
})
export class UploadComponent implements OnInit {
  @ViewChild('dtMezzi') dtMezzi: DataTableComponent;
  @ViewChild('dtPersone') dtPersone: DataTableComponent;
  uploadsListMezzi: ICaricamentoMassivo[]     // table data source
  uploadsListPersone: ICaricamentoMassivo[]     // table data source

  fileName: string  // name of file already uploaded
  uploadedFile: any //for upload file
  attachmentUrl: string = ""// url dell'allegato
  acceptedFiles: string = ".csv";

  DTT = Enum.DATA_TABLE_TYPE_ENUM //export enum for html

  constructor(private translate: TranslateService,
    private alertUtil: AlertUtil,
    private dialogService: DialogService,
    private caricamentiMassivi: CaricamentiMassiviService) { }

  ngOnInit() {
    setTimeout(() => {
      this.getAllCaricamenti(Enum.CARICAMENTO_MASSIVO_ENUM.MEZZO)
    }, 0)
  }

  /**
   * on tab selected
   * @param event 
   */
  onTabSelected(event) {
    if (event && event.index >= 0) {
      this.getAllCaricamenti(event.index)
    }
  }

  /**
   * callback fired when file is uploaded
   * @param event 
   * @param upload 
   * @param isMezzo 
   */
  caricaFile(event: any, upload: any, isMezzo: boolean) {
    this.uploadedFile = null
    this.fileName = ''
    upload.clear()
    if (event.files) {
      this.uploadedFile = event.files[0];
      this.fileName = this.uploadedFile.name
    }
    this.caricamentoMassivo(isMezzo)
  }

  /**
   * chiamata per caricamento massivo
   * @param reqBuilder 
   * @param isMezzo 
   */
  caricamentoMassivo(isMezzo: boolean) {
    Loading.isLoading = true
    this.caricamentiMassivi.caricamentoMassivo(this.uploadedFile, this.fileName, isMezzo).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.alertUtil.showAlert('LBL_FILE_CARICATO', null, null, null, () => {
            this.getAllCaricamenti(isMezzo ? Enum.CARICAMENTO_MASSIVO_ENUM.MEZZO : Enum.CARICAMENTO_MASSIVO_ENUM.PERSONA)
          })
        } else {
          console.log("Errore nel caricamento dell'allegato" + JSON.stringify(response));
        }
      })
  }

  /**
   * retrieve all caricamenti
   */
  getAllCaricamenti(entita: number) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({
      TipoEntita: entita
    })
    this.uploadsListMezzi = []
    this.uploadsListPersone = []
    this.caricamentiMassivi.getAllCaricamentiMassivi(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe((res) => {
      if (res && res.data) {
        if (entita == Enum.CARICAMENTO_MASSIVO_ENUM.MEZZO) {
          this.uploadsListMezzi = res.data
        } else {
          this.uploadsListPersone = res.data
        }
      } else if (res.error) {
        let errorKey = 'LBL_ERROR_' + res.error.Code
        this.alertUtil.showErrorAlert(errorKey)
        console.log('ERROR: ' + res.error.Stack)
      } else {
        this.alertUtil.showErrorAlert('LBL_SERVER_ERROR_GENERIC', {
          error: res.Message,
        })
      }
    }, (error) => {
      let errorKey = 'LBL_HTTP_ERROR_0'
      if (error.status) {
        errorKey = 'LBL_HTTP_ERROR_' + error.status
      }
      this.alertUtil.showErrorAlert(errorKey)
    })
  }

  /**
   * Modifica del 17.01.2025
   * Aggiunta estensione al nome file quando chiama Util.downloadFile() per evitare errori di download
   * @param caricamento 
   */
  downloadFile(caricamento: ICaricamentoMassivo) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({
      Id: caricamento.Id
    })
    this.caricamentiMassivi.downloadEsito(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(response => {
      if (response && response["error"] == null) {
        let nomeFile = caricamento.NomeFileSorgente.split('.csv')
        Util.downloadFile(
          response, 
          Enum.FILE_TYPE_ENUM.XLSX, 
          `Esito_${nomeFile[0]}${Enum.FILE_TYPE_ENUM.XLSX}`
        )
      }
      else if (response.error) {
        let errorKey = "LBL_ERROR_" + response.error.Code
        this.alertUtil.showErrorAlert(errorKey)
        console.log("ERROR: " + JSON.stringify(response.error.Stack))
      }
      else {
        this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
      }
    },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }
}
